<template>
  <b-container
    class="pt-3"
    fluid>
    <b-row>
      <b-col>
        <file-breadcrumb
          v-if="fileDetails"
          :file-details="fileDetails"
          :file-name="fileDetails.file.name" />
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col cols="4">
        <h5>Override</h5>
        <json-tree-editor
          div-class="json-halfheight-viewer"
          :original-json="originalOverrideJSON"
          @json-change="setCode" />
        <json-diff-viewer
          div-class="json-halfheight-viewer"
          div-ref="jsonOverrideViewer"
          :original-json="originalOverrideJSON"
          :show-unchanged="true"
          :changed-json="changedOverrideJSON"
          @json-diff-change="setDiff" />
      </b-col>
      <b-col cols="4">
        <h5>Base Config</h5>
        <json-tree-editor
          div-ref="jsonBaseViewer"
          div-class="json-fullheight-viewer"
          :original-json="baseJSON"
          :read-only="true"
          :modes="['code','tree']" />
      </b-col>
      <b-col cols="4">
        <div
          style="margin-bottom: 0.1rem;"
          class="d-flex bd-highlight">
          <div class="w-100 bd-highlight">
            <span class="h4">
              Merged Result
            </span>
            <b-form-checkbox
              v-model="showUnchanged"
              class="ml-4">
              <small>Show Unchanged</small>
            </b-form-checkbox>
          </div>
          <div class="flex-shrink-1 bd-highlight">
            <b-btn
              v-b-modal.submitApproval
              :disabled="!validForReview"
              class="xl-wide"
              variant="primary">
              Review
            </b-btn>
          </div>
        </div>
        <json-tree-editor
          div-ref="jsonDiffViewer"
          div-class="json-halfheight-viewer"
          :original-json="changedJSON"
          :read-only="true"
          :modes="['tree','code']" />
        <json-diff-viewer
          div-ref="jsonDiffViewer"
          div-class="json-halfheight-viewer"
          :original-json="originalJSON"
          :show-unchanged="showUnchanged"
          :changed-json="changedJSON" />
      </b-col>
    </b-row>
    <submit-approval-modal
      v-if="fileDetails"
      id="submitApproval"
      :file-id="fileDetails.file.id"
      :file-name="fileDetails.file.name"
      :override-id="fileDetails.id"
      :file-details="fileDetails"
      :original-json="originalOverrideJSON"
      :json-diff="jsonOverrideDiffToSave" />
  </b-container>
</template>

<script>
  import { File, Override } from '@/services/api'
  import SubmitApprovalModal from "@/components/SubmitApprovalModal"
  import FileBreadcrumb from "@/components/FileBreadcrumb"
  import JsonTreeEditor from "@/components/JsonTreeEditor"
  import JsonDiffViewer from "@/components/JsonDiffViewer"

  export default {
    name: "OverrideFileEditor",
    components: {JsonDiffViewer, JsonTreeEditor, FileBreadcrumb, SubmitApprovalModal},
    data() {
      return {
        fileDetails: null,
        validForReview: false,
        baseJSON: null,
        originalOverrideJSON: null,
        changedOverrideJSON: null,
        originalJSON: null,
        changedJSON: null,
        jsonOverrideDiffToSave: null,
        showUnchanged: true,
      }
    },
    async mounted() {
      this.fileDetails = await Override.details(this.$route.params.id)
      this.originalOverrideJSON = await Override.retrieve(this.$route.params.id)
      this.baseJSON = await File.retrieve(this.fileDetails.file.id)
      this.originalJSON = Object.assign({}, this.baseJSON, this.originalOverrideJSON)
      this.changedJSON = Object.assign({}, this.originalJSON, this.changedOverrideJSON)
    },
    methods: {
      setCode(newText) {
        try {
          this.changedOverrideJSON = JSON.parse(newText)
          this.changedJSON = Object.assign({}, this.originalJSON, this.changedOverrideJSON)
          this.validForReview = true
        } catch (err) {
          // unable to parse JSON, return
          this.validForReview = false
        }
      },
      setDiff(newVal) {
        this.jsonOverrideDiffToSave = newVal
      },
    },
  }
</script>

<style scoped>
  @import "~jsoneditor/dist/jsoneditor.min.css";
  @import "~jsondiffpatch/lib/formatters/styles/html.css";

  div >>> .json-fullheight-viewer {
    width: auto;
    height: 725px;
  }

  div >>> .json-halfheight-viewer {
    width: auto;
    height: 360px;
  }
</style>
